/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     NAME: seo.ts
   AUTHOR: Harikrishnan Gangadharan
 COMMENTS: 

/***************************************************************************************************************************
 DEFINITIONS
****************************************************************************************************************************/
const SEOMetadata: Record<string, string> = {
  siteName: 'TRANSCAD - Engineering & Detailing',
  siteUrl: 'https://www.mytedc.com',
  siteLogo: '/assets/images/logo.png',
  siteLogoWidth: '512',
  siteLogoHeight: '512',
  email: 'info@mytedc.com',
  description:
    'Transforming Visions into Reality! Explore Transcad Engineering & Detailing – Where Expertise Meets Ingenuity. Elevate your projects with our precision engineering, meticulous detailing, and innovative solutions. Your journey to excellence starts here.'
};

export default SEOMetadata;
